export default __webpack_public_path__ + "static/gdynia-n3miasto-d30781fce6ffdd042ced9ce2d87ea325.jpg";